import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { Avatar, Chip, Divider, Box } from '@material-ui/core';
import clsx from 'clsx';
import * as Icon from 'react-feather';

const UserProfileCard = ({ classes, profile }) => {
    return (
        <Box className={clsx('u-p-small')}>
            <div className="u-text-center">
                <Avatar
                    className={clsx(
                        'u-mb-small u-inline-flex',

                        classes.borderPrimary,
                        classes.borderBold
                    )}
                >
                    <Icon.User className={clsx(classes.colorPrimary)} />
                </Avatar>

                <h5>{profile.name}</h5>
                <p>
                    {profile.directory}/{profile.qsId}
                </p>
            </div>
            <Divider className={'u-mt-small u-mb-small'} />

            <p className={'c-text--subtitle'}>Email Address</p>
            <p className={clsx('u-mb-small u-text-large')}>{profile.email}</p>
            <p className="c-text--subtitle">Role</p>
            <p className={clsx('u-mb-small u-text-large')}>{profile.role}</p>
            <p className="c-text--subtitle u-block">Status</p>
            <Chip
                label={profile.active ? 'Active' : 'In Active'}
                className={
                    profile.active
                        ? clsx(
                              classes.borderPrimary,
                              classes.colorPrimary,

                              classes.borderBold,
                              'u-mt-small'
                          )
                        : clsx(
                              classes.borderSecondary,
                              classes.backgroundLight,
                              classes.colorSecondary,
                              classes.borderBold,
                              'u-mt-small'
                          )
                }
            />
            <p className="c-text--subtitle u-mt-small">Filter Values</p>
            {profile['filterValue'] ? (
                <div>
                    {profile['filterValue'].map((userFilterValue) => (
                        <NavLink
                            key={userFilterValue._id}
                            to={`/settings/dag/filter-values/${userFilterValue._id}/view`}
                            className={`c-badge u-mt-small u-mr-small c-badge--small ${classes.badgePrimary} u-mb-xsmall`}
                        >
                            {userFilterValue.title}
                        </NavLink>
                    ))}
                    <br />
                    <small className={'text-muted'}>
                        Select filter value to see associated filter, dynamic
                        applications and users
                    </small>
                </div>
            ) : (
                <span
                    className={`c-badge u-mt-small c-badge--small ${classes.badgePrimary} u-mb-xsmall`}
                >
                    Nothing to show
                </span>
            )}
        </Box>
    );
};

UserProfileCard.propTypes = {
    classes: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
};

export default UserProfileCard;
